<script>
    import API from "../services/Api";

    let waitingRequest = false;
    let ticketNotFound = false;
    let badRequest = false;
    let stockCreated = false;
    let requestFailed = false;
    let connectionFailed = false;
    let data = {};
    let request = {};
    let stock = {};

    let pesquisar = async () => {
        ticketNotFound = false;
        requestFailed = false;
        connectionFailed = false;
        stockCreated = false;
        data = [];
        request = {};
        stock = {};

        waitingRequest = true;

        await API.get("reportB2B")
            .then((response) => {
                data = response.data;
                waitingRequest = false;
            })
            .catch((err) => {
                if (err.response) {switch (err.response.status) {
                        case 404:
                            ticketNotFound = true;
                            break;
                        case 500:
                            requestFailed = true;
                            break;
                    }
                } else {
                    connectionFailed = true;
                }
                waitingRequest = false;
            });
    };

    pesquisar();

    let submit = async () => {
        waitingRequest = true;
        requestFailed = false;
        connectionFailed = false;
        badRequest = false;
        stock = {};

        await API.post("reportB2B", request)
            .then((response) => {
                stock = response.data;
                stockCreated = true;
                waitingRequest = false;
                pesquisar();
            })
            .catch((err) => {
                if (err.response) {
                    switch (err.response.status) {
                        case 400:
                            badRequest = true;
                            break;
                        case 500:
                            requestFailed = true;
                            break;
                    }
                } else {
                    connectionFailed = true;
                }
                waitingRequest = false;
            });
    };
</script>

<main>
    <div class="">
        <div class="card-body">
            {#if !waitingRequest}
            <div class="form-group row">
                <div class="col-md-6">
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label class="form-label">Informe a data inicial</label>
                    <input type="date"
                      placeholder="Informe a data inicial"
                      bind:value={request.dateInitial}
                      class="form-control"
                      name="dateInitial"
                      min="2022-01-01"
                      max={new Date().toISOString().split('T')[0]}/>
                  </div>
                <div class="col-md-6">
                  <!-- svelte-ignore a11y-label-has-associated-control -->
                  <label class="form-label">Informe a data final</label>
                  <input type="date"
                    placeholder="Informe a data final"
                    bind:value={request.dateEnd}
                    class="form-control"
                    name="dateFinal"
                    min="2022-01-01"
                    max={new Date().toISOString().split('T')[0]}/>
                </div>
              </div>
              <div class="form-group">
                <button class="btn btn-outline-secondary" on:click={submit}>Gerar novo relatório</button>
              </div>
            {:else}
                <div class=""><span>Aguarde...</span></div>
            {/if}

            {#if ticketNotFound}
                <div class="text-danger text-center">
                    Chamado não encontrado.<br />Verifique as informações e
                    tente novamente!
                </div>
            {/if}

            {#if stockCreated}
                <div
                    class="alert alert-success d-flex align-items-center"
                    role="alert">
                    <svg class="bi flex-shrink-0 me-2" width="24" height="24">
                        <use xlink:href="#check-circle-fill" /></svg>
                    <div>Solicitação realizada com sucesso!</div>
                </div>
            {/if}

            {#if requestFailed}
                <div class="text-danger text-center">
                    Não foi possível realizar a pesquisa.<br />
                    Tente novamente em instantes!
                </div>
            {/if}

            {#if connectionFailed}
                <div class="text-danger text-center">
                    Houve falha de comunicação com o servidor.<br />
                    Tente novamente em instantes!
                </div>
            {/if}

            <table class="table">
                <thead>
                    <th>ID</th>
                    <th>Arquivo</th>
                    <th>Usuário</th>
                    <th>Data</th>
                    <th>Data Inicial</th>
                    <th>Data Final</th>
                    <th>#</th>
                </thead>
                <tbody>
                    {#each data as report}
                    <tr>
                        <th>{report.id}</th>
                        <th>{report.file}</th>
                        <th>{report.username}</th>
                        <th>{`${report.date.split(' ', 2)[0].split('-').reverse().join('/')} ${report.date.split(' ', 2)[1]}`}</th>
                        <th>{JSON.parse(report.filters).dateInitial ? JSON.parse(report.filters).dateInitial.split('-').reverse().join('/') : ""}</th>
                        <th>{JSON.parse(report.filters).dateEnd ? JSON.parse(report.filters).dateEnd.split('-').reverse().join('/') : ""}</th>
                        <th>
                            <a href="./{report.file}" target="_blank">Baixar</a>
                        </th>
                    </tr>
                    {/each}
                </tbody>
            </table>
        </div>
    </div>
</main>
